import { Injectable, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { Store } from '@ngrx/store';
import { Observable, filter, map, of, switchMap, takeUntil, tap, timer } from 'rxjs';
import { MILLISECONDS_PER_SECOND } from 'time-constants';

import { PermissionStoreModelEnum } from '@domain/profile';

import { UserService } from '@shared/services/user';

import { fromCore } from '@stores/core';
import { CrisisActions, fromCrisis } from '@stores/crisis';

const REFRESH_INTERVAL_10_SECONDS = 10;

@Injectable()
export class SideMenuService {
  readonly #userService = inject(UserService);
  readonly #store = inject(Store);

  readonly #hasViewCrisisPermission$ = this.#store.select(fromCore.selectUserHasPermissions$([PermissionStoreModelEnum.VIEW_CRISIS]));
  readonly #hasCrisis$: Observable<boolean> = this.#hasViewCrisisPermission$.pipe(
    switchMap((hasPermission) => (hasPermission ? this.createCheckCrisisTimerObservable$() : of(false)))
  );
  readonly #isLoggedIn$ = this.#userService.accessTokens$.pipe(map(() => !!this.#userService.accessToken));

  public readonly hasCrisis = toSignal(this.#hasCrisis$);
  public readonly isLoggedIn = toSignal(this.#isLoggedIn$);

  private createCheckCrisisTimerObservable$(): Observable<boolean> {
    return timer(0, REFRESH_INTERVAL_10_SECONDS * MILLISECONDS_PER_SECOND).pipe(
      tap(() => this.#store.dispatch(CrisisActions.checkCrisis())),
      switchMap(() => this.#store.select(fromCrisis.selectIsCrisis$)),
      takeUntil(this.#hasViewCrisisPermission$.pipe(filter((hasPermissionToViewCrisis) => !hasPermissionToViewCrisis)))
    );
  }
}
